import { createApi, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query/react'
import { AppState } from '@redux/store'
import { CartBundle } from '@typesApp/Product'
import { ActionModule } from '@typesApp/ActionModule'
import { HostEnvironment, HostSession } from '@typesApp/Environment'
import { Logger } from '@utils/logger'
import { apiConfigurationError, getCommerceApiUrl, getRequestHeaders } from '@utils/apiUtil'

export const cartApi = createApi({
  reducerPath: 'cartApi',
  baseQuery: fetchBaseQuery(),
  keepUnusedDataFor: 300,
  tagTypes: ['Cart'],
  endpoints: builder => ({
    getCartItems: builder.query<CartBundle, void>({
      queryFn: async (_args, queryApi, _extraOptions, fetchFn) => {
        const state = queryApi.getState() as AppState
        const hostSession = state.connector.session as HostSession
        const isPartiallyAuthenticated = hostSession?.isPartiallyAuthenticated
        const env = state.connector?.environment as HostEnvironment
        const actionModule = state.connector.actionModule as ActionModule

        if (typeof actionModule?.getCartItemDetails === 'function') {
          try {
            const data = await actionModule.getCartItemDetails()
            return { data }
          } catch (error) {
            return { error: error as FetchBaseQueryError }
          }
        }

        if (!env?.ecommerceTransactionHost) {
          return apiConfigurationError('cartItems')
        }

        try {
          const headers = getRequestHeaders(isPartiallyAuthenticated, hostSession)
          const url = getCommerceApiUrl(env, 'cartItems')
          const result = (await fetchFn({
            url,
            method: 'GET',
            headers,
            credentials: 'include',
          })) as { data: CartBundle; error?: unknown }

          if (result.error) {
            return { error: result.error as FetchBaseQueryError }
          }

          return { data: result.data }
        } catch (error) {
          Logger.error('Error calling commerce cart items API', error)
          return { error: error as FetchBaseQueryError }
        }
      },
    }),
  }),
})

export const { useGetCartItemsQuery, useLazyGetCartItemsQuery } = cartApi
